module.exports = __webpack_public_path__ + "static/media/ike.6bb47a67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ike.jpg
// module id = 211
// module chunks = 0